module.exports = __webpack_public_path__ + "static/media/add-tank-icon.50d69854.svg";